<template>
  <div class="mall-month-data-detail">
    <div class="detail-content">
      <div class="detail-content__inner">
        <div class="chart-title">{{ data.name }}收益</div>
        <div class="chart-content">
          <MallMonthDataDetailChart2 :list="chartList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpecificIncome } from 'src/api/showker'
import MallMonthDataDetailChart2 from './MallMonthDataDetailChart2'

export default {
  name: 'MallMonthDataDetail2',
  components: {
    MallMonthDataDetailChart2
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    showkerId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      chartList: []
    }
  },
  mounted() {
    this.getChartData()
  },
  methods: {
    async getChartData() {
      const groupId = {
        h5: 2,
        h2: 7,
        h5l: 10,
        video: 15,
        gc: 14,
        h5e: 11
      }
      try {
        const { data } = await getSpecificIncome({
          showkerId: this.showkerId,
          attrGroupId: groupId[this.data.key]
        })
        if (data && data.obj) {
          const { templateList } = data.obj
          // 订单收益
          if (templateList && templateList.length) {
            this.chartList = templateList.map(item => {
              return {
                date: item.dateTime,
                value: +(item.todayAllIncome / 100).toFixed(2)
              }
            })
          }
        }
      } catch (e) {
        throw e
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mall-month-data-detail {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: hidden;
    border: 1px solid #E6EBED;
    border-radius: 4px;

    .detail-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &__inner {
          position: relative;
          width: 70%;
          height: 62%;
          min-width: 852px;
          min-height: 400px;
        }

        .chart-title {
          height: 16px;
          margin-bottom: 38px;
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }

        .chart-content {
          width: 100%;
          height: calc(100% - 54px);
        }
    }
}
</style>
